import Konva from 'konva/konva'
import AnalogueVariableScale from './analogue-variable-scale'
import CategoryVariableScale from './category-variable-scale'

export const width = 30

export default class YScaleLayer extends Konva.Layer {
  constructor ({ name }) {
    super({ name })
  }

  init ({ stageWidth, height, yScaleData }) {
    Object.assign(this, { height, yScaleData })
    this.x(stageWidth - width)

    this._render()
  }

  _render () {
    const { height } = this
    this.destroyChildren()

    this.add(new Konva.Rect({
      x: 0,
      y: 0,
      width: width,
      height,
      fill: 'White'
    }))

    this.yScaleData
      .map(({ type, yFrom, yTo, minValue, maxValue, values }) => {
        switch (type) {
          case 'analogue':
            return new AnalogueVariableScale({ width, yFrom, yTo, minValue, maxValue })
          case 'category':
            return new CategoryVariableScale({ width, yFrom, yTo, values })
        }
        throw new Error('Unknown variable type: ' + type)
      })
      .forEach(shape => this.add(shape))

    this.draw()
  }
}
